"use strict";

exports.__esModule = true;
exports.Value = exports.TooltipTable = exports.TooltipRow = exports.TooltipCell = exports.TextValue = exports.ColorBlock = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = require("../../../Theme");
var _whenModern = require("../../../Theme/UiDesign/whenModern");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var TooltipTable = exports.TooltipTable = _styledComponents["default"].table.withConfig({
  displayName: "tooltipStyles__TooltipTable",
  componentId: "sc-1qv6zb2-0"
})(["background:", ";min-width:200px;text-align:left;border-spacing:0;border-collapse:collapse;padding:", ";font-size:12px;"], function (props) {
  return props.theme.primaryBackgroundColor;
}, (0, _Theme.val)("padding"));
var TooltipRow = exports.TooltipRow = _styledComponents["default"].tr.withConfig({
  displayName: "tooltipStyles__TooltipRow",
  componentId: "sc-1qv6zb2-1"
})(["height:12px;margin:0;padding:0;"]);
var TooltipCell = exports.TooltipCell = _styledComponents["default"].td.withConfig({
  displayName: "tooltipStyles__TooltipCell",
  componentId: "sc-1qv6zb2-2"
})(["margin:0;padding:2px;border-bottom:", ";text-align:", ";width:", "px;"], function (props) {
  return "1px solid " + props.theme.borderColor;
}, function (props) {
  return props.align;
}, function (props) {
  return props.width;
});
var ColorBlock = exports.ColorBlock = _styledComponents["default"].div.withConfig({
  displayName: "tooltipStyles__ColorBlock",
  componentId: "sc-1qv6zb2-3"
})(["background:", ";", " margin:0px;"], function (props) {
  return props.color;
}, (0, _whenModern.whenModern)((0, _styledComponents.css)(["width:9px;height:9px;border-radius:2px;"]), (0, _styledComponents.css)(["width:12px;height:12px;"])));
var TextValue = exports.TextValue = _styledComponents["default"].span.withConfig({
  displayName: "tooltipStyles__TextValue",
  componentId: "sc-1qv6zb2-4"
})(["color:", ";font-weight:", ";margin:0;padding:0 2px;line-height:10px;"], function (props) {
  return props.theme.primaryTextColor;
}, function (props) {
  return props.bold ? "bold" : "normal";
});
var Value = exports.Value = (0, _styledComponents["default"])(TextValue).withConfig({
  displayName: "tooltipStyles__Value",
  componentId: "sc-1qv6zb2-5"
})(["margin-right:4px;"]);